import React from 'react'
import classNames from 'classnames'
import { urlWithParams } from '../../lib/utils/common'

export const formatDuration = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds - (hours * 3600)) / 60)
  let seconds = totalSeconds - (hours * 3600) - (minutes * 60)

  seconds = Math.round(seconds * 100) / 100
  let result = ''
  if(hours !== 0) {
    result = (hours < 10 ? '0' + hours : hours) +':'
  }
  result += (minutes < 10 ? '0' + minutes : minutes)
  result += ':' + (seconds  < 10 ? '0' + seconds : seconds)
  return result
}

/**
 * React Video element
 * @param {String} id - The video id
 * @param {String} headline - The video headline
 * @param {String} description - The video description
 * @param {String} source - The video source CMS ex: (intl, deportes, espn)
 * @param {String} thumbnail - The video thumbnail URL
 * @param {String} scoringPlay - Whether or not the video is of a scoring play
 * @return {React.PropTypes.element} Video elem
 */

// TODO: localize 'play' label
export const Video = ({
    id = '',
    headline = '',
    description = '',
    source = '',
    thumbnail = '',
    className = '',
    duration = '',
    feedItemFigure = false,
    showCaption = false,
    forNewsFeed = false,
    inlineStyles = {},
    thumbs = [],
    showDuration = true
  }) => {
  if(!thumbs.length) {
    thumbs = [ {
      srcSet: urlWithParams(thumbnail, 'w=943', 'h=530'),
      mediaQuery: '(min-width: 376px)'
    },{
      srcSet: [ urlWithParams(thumbnail, 'w=375'), urlWithParams(thumbnail, 'w=750', 'cquality=40 2x') ].join(','),
      mediaQuery: '(max-width: 375px)'
    } ]
  }
  const durationMarkup = !forNewsFeed && showDuration ? `<span class="video-length">${duration ? formatDuration(duration) : ''}</span>` : ''
  const imgWrapContents = `
    <picture>
      ${ thumbs.map(thumb => { return `<source data-srcset="${thumb.srcSet}" media="${thumb.mediaQuery}" />` }) }
      <img class="lazyload" data-image-container=".article-figure" />
    </picture>
    <span class="video-play-button" data-id="${id}">play</span>
    ${durationMarkup}
  `
  /*
  // Settings for all sources of the video thumbnail images
  let allSources = [ {
    config: [ {
      combinerOptions: {
        w: 943,/
        h: 530
      }
    } ],
    mediaQuery: '(min-width: 376px)'
  }, {
    config: [ {
      combinerOptions: {
        w: 375
      }
    }, {
      combinerOptions: {
        w: 750,
        cquality: 40
      },
      others: '2x'
    } ],
    mediaQuery: '(max-width: 375px)'
  } ]
  */
  const Entities = require('html-entities').XmlEntities
  const entities = new Entities()
  let textDescription = entities.decode(description)
  let textHeadline = entities.decode(headline)

  return (
      <figure style={inlineStyles} data-video={ 'native,640,360,' + id } className={ classNames(className, feedItemFigure ? 'feed-item-figure' : 'iframe-video', 'article-figure', 'video') } data-source={ source }>
        {/*
        <div className="img-wrap">
          <Picture
            thumbnail = { thumbnail }
            imgClasses = { { lazyload : true } }
            imgContainer = {'.article-figure' }
            allSources = { allSources }
          />
          <span className="video-play-button" data-id={id}>play</span>
          <span className="video-length">{duration ? formatDuration(duration) : ''}</span>
        </div>
        */}

        <div className="img-wrap" dangerouslySetInnerHTML={{ __html: imgWrapContents }} />

        {
          showCaption &&
          <figcaption>
            <div className="caption-wrapper">
            {forNewsFeed &&
              <div className="text-container">
                <span className="headline">{ headline } ({duration ? formatDuration(duration) : ''})</span>
              </div>
            }
            {!forNewsFeed &&
              <div className="text-container">
                <span className="headline">{ headline }</span>
                <p dangerouslySetInnerHTML={{ __html: textDescription || textHeadline }} />
              </div>
            }
            </div>
          </figcaption>
        }
      </figure>
  )
}

export default Video



// WEBPACK FOOTER //
// ../app/components/common/Video.jsx